import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
    check_in_id: "IdRef", // optional Mã ddat checkin (nếu có)
    nguoi_danh_gia_id: null, // IdRef, optional // Mã người đánh giá
    doi_tuong_danh_gia_id: null, // IdRef, optional // Mã tour, mã hướng dẫn viên du lịch hoặc mã dịch vụ du lịch được đánh giá (phụ thuộc vào trường loai_doi_tuong_danh_gia)
    loai_doi_tuong_danh_gia: null, // string, optional // Loại đánh giá, dùng để phân biệt giá trị trong trường doi_tuong_danh_gia_id
    gia_tri: null, // integer, optional // Số sao đánh giá của người dùng
    thanh_phan: [{ //array of object, optional // Danh sách các đánh giá thành phần
        nhom_id: null, // IdRef, optional // Mã nhóm thành phần
        gia_tri: null, // integer, optional // Giá trị đánh giá thành phần
    }],
    noi_dung: null, // string, optional // Nội dung đánh giá
    thoi_diem_tao: null, // datetime, optional // Thời điểm tạo
    thong_tin_them: null,
};

// validation form
model.validForm = {
    nguoi_danh_gia_id: [ValidService.required], // IdRef, optional // Mã người đánh giá
    doi_tuong_danh_gia_id: [ValidService.required], // IdRef, optional // Mã tour, mã hướng dẫn viên du lịch hoặc mã dịch vụ du lịch được đánh giá (phụ thuộc vào trường loai_doi_tuong_danh_gia)
    loai_doi_tuong_danh_gia: [ValidService.required], // string, optional // Loại đánh giá, dùng để phân biệt giá trị trong trường doi_tuong_danh_gia_id
    gia_tri: [], // integer, optional // Số sao đánh giá của người dùng
    thanh_phan: [{ //array of object, optional // Danh sách các đánh giá thành phần
        nhom_id: [], // IdRef, optional // Mã nhóm thành phần
        gia_tri: [], // integer, optional // Giá trị đánh giá thành phần
    }],
    noi_dung: [], // string, optional // Nội dung đánh giá
    thoi_diem_tao: [], // datetime, optional // Thời điểm tạo
    thong_tin_them : [],
};

// dữ liệu mẫu các form khác
model.dataFormOther = {
    thanh_phan: [{
        nhom_id: null, // IdRef, optional // Mã nhóm thành phần
        gia_tri: null, // integer, optional // Giá trị đánh giá thành phần
    }],
    kpis:[],
};

// validation các form khác
model.validFormOther = {};

model.loaiDoiTuongDanhGia = [{
        code: "tour",
        text: "Tour du lịch"
    },
    {
        code: "tour_guide",
        text: "Hướng dẫn viên"
    },
    {
        code: "hq_service",
        text: "Dịch vụ du lịch clc"
    },
    {
        code: "safe_place",
        text: "Điểm đến"
    },
    {
        code: "accommodation",
        text: "Cơ sở lưu trú"
    },
    {
        code: "tourist",
        text: "Khách du lịch"
    },
];

model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["thoi_diem_tao", "descending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            loai_doi_tuong_danh_gia: "",
            doi_tuong_danh_gia_id: "",
            gia_tri: "",
            thoi_diem_tao: "",
        },
        valid: {
            loai_doi_tuong_danh_gia: [],
            doi_tuong_danh_gia_id: [],
            gia_tri: [],
            thoi_diem_tao: []
        },
        operator: {
            gia_tri: "=",
            thoi_diem_tao: ":in_that_day:"
        }
    }
};

export default model;
